import { CUBE_AGGREGATE_INTERACTION } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { CubeQuery, GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfig } from '@/types/filter';

const INTERACTION_TYPE_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => {
  const query: CubeQuery = {
    dimensions: [`${sourceCube}.global_local_type`],
    filters: [],
    limit: undefined,
  };

  return query;
};

const interactionTypeFilter: FilterConfig = {
  label: 'main.channelFocus.hcpCoverage.filters.interactionType.label',
  placeholder: 'main.channelFocus.hcpCoverage.filters.interactionType.placeholder',
  clearable: true,
  type: 'multiselect',
  defaultValue: [],
  sourceCube: CUBE_AGGREGATE_INTERACTION,
  getOptionsQuery: INTERACTION_TYPE_OPTIONS,
  mapResult: mapDimensionToOption(`${CUBE_AGGREGATE_INTERACTION}.global_local_type`),
  applyFilter: selectedInteractionTypes => {
    const interactionTypes = selectedInteractionTypes as string[];

    return {
      member: `${CUBE_AGGREGATE_INTERACTION}.global_local_type`,
      operator: 'equals',
      values: [...interactionTypes],
    };
  },
};

export default interactionTypeFilter;
